/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { service } from '@ember/service';
import { alias } from '@ember/object/computed';

export default class AttendanceTermAuditListRoute extends Route {
  queryParams = {
    dateFrom: {
      refreshModel: true,
    },
    dateTo: {
      refreshModel: true,
    },
  };

  // Attrs
  @alias('session.school.jurisdiction')
  jurisdiction;

  // Services
  @service
  session;

  @service
  store;

  // State
  dateFrom = moment().format('YYYY-01-01');

  dateTo = moment().format('YYYY-12-31');

  model(params) {
    let dateFrom = params.dateFrom || this.dateFrom;
    let dateTo = params.dateTo || this.dateTo;
    let schoolId = this.get('session.activeSchool');

    let data = {
      people: this.store.query('person', {
        type: PersonType.LEARNER,
        includeFormer: true,
      }),
      // Resolved to a plain array: the {{reverse}} template helper calls
      // A() on it, which throws on ember-data's live-array proxy.
      terms: this.store.findAll('term').then((terms) => terms.slice()),
      dates: this.store.query('date', { schoolId, from: dateFrom, to: dateTo }),
    };

    if (this.jurisdiction !== Jurisdiction.NZ_MOE) {
      data.dayCodes = this.store.query('attendance/nz-moe-day', {
        dateFrom,
        dateTo,
      });
    } else {
      data.records = this.store.query('attendance/record', {
        dateFrom,
        dateTo,
      });
    }

    return hash(data);
  }
}
